import { render, staticRenderFns } from "./JuYiDigitalScreen.vue?vue&type=template&id=6b6aa69c&"
import script from "./JuYiDigitalScreen.vue?vue&type=script&lang=js&"
export * from "./JuYiDigitalScreen.vue?vue&type=script&lang=js&"
import style0 from "./JuYiDigitalScreen.vue?vue&type=style&index=0&id=6b6aa69c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports